import { fetchMaterialSizes, fetchMaterialTypes } from "../services/MaterialAPI";
import { Messages } from "../constants/Messages";
import { normalizeString } from "./AlertUtils";

export const fetchMaterialMappings = async (): Promise<{
    materialTypeMap: Record<string, number>;
    materialSizeMap: Record<string, number>;
}> => {
    try {
        const [ types, sizes ] = await Promise.all([ fetchMaterialTypes(), fetchMaterialSizes() ]);

        const materialTypeMap = types.reduce(
            (map: { [key: string]: number }, type: { id: number; material_type: string }) => {
                map[normalizeString(type.material_type)] = type.id;
                return map;
            }, {});

        const materialSizeMap = sizes.reduce((map: { [key: string]: number }, size: { id: number; size: string }) => {
            map[normalizeString(size.size)] = size.id;
            return map;
        }, {});
        return { materialTypeMap, materialSizeMap };
    } catch (error) {
        throw new Error(Messages.ERROR_FETCH_MAPPINGS);
    }
};
export const loadMaterialMappings = async (
    setMaterialMappings: {
        (value: React.SetStateAction<{
            materialTypeMap: Record<string, number>;
            materialSizeMap: Record<string, number>;
        }>): void;
        (arg0: { materialTypeMap: Record<string, number>; materialSizeMap: Record<string, number> }): void;
    },
    setErrorAlert: React.Dispatch<React.SetStateAction<{ message: string } | null>>,
) => {
    try {
        setMaterialMappings(await fetchMaterialMappings());
    } catch (error) {
        setErrorAlert({
            message: Messages.ERROR_FETCH_MAPPINGS,
        });
    }
};


export const mapMaterialTypes = (types: string[]) => {
    return types.map((material_type) => ({
        material_type,
    }));
};

export const mapMaterialSize = (sizes: string[]) => {
    return sizes.map((size) => ({
        size,
    }));
};